export default {
  title: "Autorización {id}",
  createdAt: "Fecha de creación",
  beneficiary: "Asegurado/a",
  memberCode: "Carnet",
  sponsor: "Aseguradora",
  coverage: "Cobertura",
  settlementId: "ID Radicación",
  doctor: "Médico",
  specialty: "Especialidad",
  licenseNumber: "No. de Exequátur",
  branch: "Centro médico",
  productName: "Tipo de consulta",
  additionalDocuments: "Documentos adicionales",
  supportDocuments: "Documentos generales",
  requiereDocuments: "Documentos requeridos",
  optionalDocuments: "Documentos opcionales",
  claim: "Reclamo",
  authorization: "Autorización",
  documentation: {
    label: "Documentación",
    incomplete: "Incompleta (Docs {uploaded}/{total})",
    complete: "Completa",
    require: "(Requerido)"
  },
  attachDialog: {
    attachFiles: "Adjuntar archivos",
    additionalFiles: "Documentos adicionales (opcional)",
    fileFormats: "Archivos en formato PDF, PNG, JPEG, XML hasta 10Mb",
    addFileDescription: "Adjunta otros documentos que consideres necesarios y relevantes para la autorización"
  },
  buttons: {
    back: "Regresar",
    attachDocument: "Adjuntar",
    addDocument: "Agregar",
    replace: 'Reemplazar'
  },
  emptyState: {
    documents: "No se encontraron documentos adicionales",
    noResults: "No se encontraron datos",
    noResultsDescription: "No se encontró el reclamo de consulta médica deseado."
  },
  preview: {
    title: "Vista previa",
    label: "Este archivo no tiene vista previa.",
    actions: {
      cancel: "Cancelar",
      download: "Descargar",
      delete: "Eliminar"
    }
  },
  diagnoses: {
    title: "Diagnóstico(s)",
    headers: {
      diagnosisCode: "Código CIE - 10",
      diagnosisName: "Nombre",
      status: "Estado"
    },
    status: {
      approved: "Aprobado",
      rejected: "Rechazado",
      manualApprovalRequired: "Revisión manual requerida"
    }
  },
  treatments: {
    title: 'Tratamientos prescritos',
    headers: {
      name: 'Medicamento',
      treatment: 'Tratamiento'
    }
  },
  products: {
    title: "Información de reclamos",
    headers: {
      productNames: {
        drugs: "Medicamento",
        diagnosticTests: "Laboratorios",
        medicalProcedures: "Procedimiento"
      },
      productName: "Medicamento",
      price: "Precio Unitario",
      refill: "Refil",
      refillValues: "{refillNumber} de {numberOfRefills}",
      quantity: "Cantidad",
      status: "Estado",
      claim: "Reclamo"
    },
    status: {
      approved: "Aprobado",
      rejected: "Rechazado",
      claimed: "Reclamado",
      manualApprovalRequired: "Revisión manual requerida",
      partiallyClaimed: "Parcialmente reclamada"
    }
  },
  void: "Anular autorización",
  voidOnlyClaim: "Anular reclamo"
}